import { mittweidaFields } from 'mittweida/inquiry/fields';
import {
  customValidations,
  fieldValidators,
} from 'modules/Inquiry/inquiryFieldValidation/customValidations';

const { gender, firstName, lastName, email, phone } =
  mittweidaFields.userProfilePage.contactPersonSection;

export const contactPersonSectionValidationMap = {
  [gender]: fieldValidators.string().required(),
  [firstName]: fieldValidators.name().isValidName().required(),
  [lastName]: fieldValidators.name().isValidName().required(),
  [email]: fieldValidators.string().required().custom(customValidations.isEmail),
  [phone]: fieldValidators
    .phoneNumber()
    .required()
    .hasPhonePrefix()
    .isPhoneNumber()
    .maxPhoneNumberLength()
    .minPhoneNumberLength(),
};
